// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

export { areDeepEqual } from './areDeepEqual';
export { isRecord } from './isRecord';
export { type MergeWithCustomizer, mergeWith } from './mergeWith';
